module.exports = __webpack_public_path__ + "static/media/pasta-bg.11e14a17.png";